import { render, staticRenderFns } from "./GiftCodeDetail.vue?vue&type=template&id=42a6faab&scoped=true&"
import script from "./GiftCodeDetail.vue?vue&type=script&lang=js&"
export * from "./GiftCodeDetail.vue?vue&type=script&lang=js&"
import style0 from "./GiftCodeDetail.vue?vue&type=style&index=0&id=42a6faab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a6faab",
  null
  
)

export default component.exports